import { ReactNode } from 'react'
import AppLayout from './AppLayout'
import { cn } from '../../lib/utils'

export interface PageShellProps {
  rail2?: ReactNode
  brow: ReactNode
  children: ReactNode
  scroll?: boolean
  className?: string
}

export function PageShell({ rail2, brow, children, scroll = true, className }: PageShellProps) {
  return (
    <AppLayout secondarySidebar={rail2}>
      <div className={cn('flex h-full flex-col bg-background', className)}>
        {brow}
        {scroll ? <div className="min-h-0 flex-1 overflow-y-auto">{children}</div> : children}
      </div>
    </AppLayout>
  )
}
